import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { FaltaMedicaDTO } from '../../dtos/falta-medica-dto';
import { Util } from '../../util/util';
import { FaltaMedicaService } from '../falta-medica.service';

@Component({
  selector: 'app-falta-medica-list',
  templateUrl: './falta-medica-list.component.html',
  styleUrls: ['./falta-medica-list.component.css']
})
export class FaltaMedicaListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['nomeMedico', 'dataFalta', 'horaFalta', 'tipoFaltaFormatado', 'details'];

  formularioDeConsultaDeFaltaMedica: FormGroup;

  constructor(private faltaMedicaService: FaltaMedicaService, router: Router,
    dialog: MatDialog, private formBuilder: FormBuilder) {

    super(router, dialog);

    this.formularioDeConsultaDeFaltaMedica = this.formBuilder.group({
      dataInicial: [''],
      dataFinal: [''],
    });

  }

  ngOnInit() {

    let dataOntem: Date = new Date();
    dataOntem.setDate(dataOntem.getDate() - 1);

    let dataAtualMais335Dias: Date = new Date();
    dataAtualMais335Dias.setDate(dataAtualMais335Dias.getDate() + 335);

    this.formularioDeConsultaDeFaltaMedica.controls.dataInicial.setValue(formatDate(dataOntem, 'yyyy-MM-dd', 'en'));
    this.formularioDeConsultaDeFaltaMedica.controls.dataFinal.setValue(formatDate(dataAtualMais335Dias, 'yyyy-MM-dd', 'en'));

    this.reloadData();

    super.ngOnInit();
  }

  onSubmit() {
    this.reloadData();
  }

  reloadData() {

    let currentDataInicial =
      formatDate(this.formularioDeConsultaDeFaltaMedica.controls.dataInicial.value, 'yyyy-MM-ddTHH:mm:ss', 'en');

    let currentDataFinal =
      formatDate(this.formularioDeConsultaDeFaltaMedica.controls.dataFinal.value, 'yyyy-MM-ddTHH:mm:ss', 'en');

    this.faltaMedicaService.listarComProjecao(currentDataInicial, currentDataFinal)
      .subscribe(data => {
        // console.log(data)

        const listaFaltaMedica: Array<FaltaMedicaDTO> = [];

        data.forEach((element: any) => {
          listaFaltaMedica.push(Object.assign(new FaltaMedicaDTO(), element));
        });

        this.data = listaFaltaMedica;

        this.configurarDataSource();
      }, error => {
        console.log(error);
      });
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.faltaMedicaService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterFaltaMedica']);
  }

  details(id: number) {
    this.router.navigate(['manterFaltaMedica'], {
      state: {
        id: id,
        isUpdate: 'N'
      }
    });
  }

  update(id: number) {
    this.router.navigate(['manterFaltaMedica'], {
      state: {
        id: id,
        isUpdate: 'S'
      }
    });
  }

  horaFormatada(hora: string): string {
    return Util.getHoraFormatada(hora);
  }

  get dataInicial() {
    return this.formularioDeConsultaDeFaltaMedica.get('dataInicial');
  }

  get dataFinal() {
    return this.formularioDeConsultaDeFaltaMedica.get('dataFinal');
  }

}
